import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject, throwError } from 'rxjs';
import { catchError, flatMap, map, mergeMap, share } from 'rxjs/operators';
import { GET_MASTER_DATA } from '../../core/constants/api-endpoints';
import { environment } from '../../../environments/environment';
import { Application } from '../../core/model/application.model';
import { User } from '../../core/model/user.model';
import { GET_ARN_DISTRIBUTOR_DATA, GET_AIF_DATA } from '../../core/constants/api-endpoints';
import { PanType } from 'src/app/core/constants/enum';
import { ApplicationListType } from 'src/app/core/model/pledge.model';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ACCESS_TOKEN, AUTHORIZATION, BEARER_TOKEN_PREFIX } from 'src/app/core/constants/app-strings';

@Injectable({
  providedIn: 'root',
})
export class CommonService {

  readonly specialCharRegex = /[^a-zA-Z0-9\s]/g;

  constructor(private http: HttpClient) { }

  private loaderState = new BehaviorSubject<boolean>(false);
  loader$ = this.loaderState.asObservable().pipe(share());

  private applicationState = new Subject<Application>();
  application$ = this.applicationState.asObservable().pipe(share());

  private userState = new Subject<User>();
  user$ = this.userState.asObservable().pipe(share());

  private holderState = new Subject<any>();
  holder$ = this.holderState.asObservable().pipe(share());

  private selectedType = new BehaviorSubject<ApplicationListType>(this.getFromStorage() || "fresh"); //This holds the selected application type
  selectedType$ = this.selectedType.asObservable();

  private getFromStorage(): ApplicationListType | null {
    const stored = localStorage.getItem('selectedType');
    return stored as ApplicationListType;
  }

  setSelectedType(type: ApplicationListType) {
    this.selectedType.next(type);
    localStorage.setItem('selectedType', type);
  }

  getSelectedType(): ApplicationListType {
    return this.selectedType.value;
  }

  clearSelectedType() {
    localStorage.removeItem('selectedType');
    this.selectedType.next('fresh'); // Reset to default
  }

  generateRequestId() {
    return Math.floor(10000000 + Math.random() * 90000000).toString();
  }

  updateApplication(application) {
    this.applicationState.next(application);
  }

  updateUser(user: User) {
    this.userState.next(user);
  }

  updateHolder(holder) {
    this.holderState.next(holder);
  }

  updateLoader(isLoading: boolean) {
    this.loaderState.next(isLoading);
  }

  getMasterData(id, type, subType?) {
    const url =
      environment.APIURL + GET_MASTER_DATA + id + '/' + type + '/' + subType;
    return this.http.get(url);
  }

  getArnAndDistributor() {
    const url =
      environment.APIURL + GET_ARN_DISTRIBUTOR_DATA;
    return this.http.get(url);
  }

  getAIFData() {
    const url =
      environment.APIURL + GET_AIF_DATA;
    return this.http.get(url);
  }

  getCCData() {
    const url =
      environment.MASTERAPIURL + "/api/Fund/getFundCC";
    return this.http.get(url);
  }

  encrypt(plainText) {
    const url =
      environment.MASTERAPIURL +
      '/api/global/Encrypt?plainText=' +
      plainText;
    //const headers = {};
    //headers[CONTENT_TYPE] = APPLICATION_JSON_CONTENT_TYPE;
    //headers[AUTHORIZATION] = '8a5148d0-e7fc-4fc5-959f-d1fdc6df4444';
    // const agent = new httpss.Agent({
    //   rejectUnauthorized: false
    // });

    return this.http.post(url, "");
  }

  decrypt(encyptedText) {
    const url =
      environment.MASTERAPIURL +
      '/api/global/Decrypt?encyptedText=' +
      encyptedText;
    //const headers = {};
    //headers[CONTENT_TYPE] = APPLICATION_JSON_CONTENT_TYPE;
    //headers[AUTHORIZATION] = '8a5148d0-e7fc-4fc5-959f-d1fdc6df4444';
    // const agent = new httpss.Agent({
    //   rejectUnauthorized: false
    // });

    return this.http.post(url, "");
  }

  isNumberKey(evt: { which: any; keyCode: any }) {
    const charCode = evt.which ? evt.which : evt.keyCode;

    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  isAlphaNumericKey(event) {
    var inp = String.fromCharCode(event.keyCode);

    if (/[a-zA-Z0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  isAlphaKey(event) {
    var inp = String.fromCharCode(event.keyCode);

    if (/[a-zA-Z- ]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  commaSeparateNumber(val: any) {
    if (val === 0 || val === null || val === '0') {
      return '0';
    }
    // tslint:disable-next-line: prefer-const
    var input = val;
    var parts = input.toString().split('.');

    var x = parts[0];
    var decimals = parts[1];

    if (x > 7) {
      var crore = x.substring(0, x.length - 7);
      var lastThree = x.substring(x.length - 3);
      var thousandlakh = x.substring(x.length - 7, x.length - 3);
    } else if (x <= 7) {
      var lastThree = x.substring(x.length - 3);
      var thousandlakh = x.substring(0, x.length - 3);
      var crore: any = '';
    } else if (x <= 5) {
      var lastThree = x.substring(x.length - 3);
      var thousandlakh = x.substring(0, x.length - 3);
      var crore: any = '';
    } else {
      var lastThree: any = '';
      var thousandlakh: any = '';
      var crore: any = '';
    }

    if (thousandlakh != '') lastThree = ',' + lastThree;

    if (crore != '') thousandlakh = ',' + thousandlakh;

    var crorefinal = crore.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var res =
      crore.replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
      thousandlakh.replace(/\B(?=(\d{2})+(?!\d))/g, ',') +
      lastThree;
    if (res == 0) return '';

    if (parts[1] && parts[1].length > 0) {
      decimals = decimals.toString().substring(2, 0);
    }
    if (val.toString().includes('.')) res = res + '.' + decimals;

    return res;
  }

  maskInput(inputData: string, type: string) {
    let val, data, first2char, last2char, domain, len, maskL;
    data = type === 'email' ? inputData.split('@') : '';
    val = type === 'email' ? data[0] : inputData;

    if (val.length >= 10) {
      len = 3;
      maskL = val.length - 5;
    } else if (val.length >= 6) {
      len = 2;
      maskL = val.length - 3;
    } else if (val.length >= 5) {
      len = 1;
      maskL = val.length - 1;
    } else {
      len = 1;
      maskL = val.length - len * 2;
    }

    const mask =
      type === 'email' ? Array(maskL).join('*') : Array(maskL).join('*');
    domain = type === 'email' ? `@` + data[1] : '';
    last2char =
      type === 'email'
        ? val.substring(val.length - len, val.length)
        : val.substring(val.length - len, val.length);
    first2char =
      type === 'email' ? val.substring(0, len) : val.substring(0, len);

    return `${first2char}${mask}${last2char}${domain}`;
  }

  setValidation(name, validator) {
    name.setValidators(validator);
    name.updateValueAndValidity();
  }

  handleNewFlow(decryptedData: any): Observable<any> {
    return this.http.post(`${environment.APIURL}/api/v1/user/validateUser`, decryptedData).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error) => {
        console.log(error)
        return throwError(() => {
          new error("error")
        })
      })
    )

  }

  getPanCardPatter(): RegExp {
    return /^[a-zA-Z]{5}\d{4}[a-zA-Z]{1}$/
  }

  getPanCardType(pan: string): PanType | undefined {

    if (pan.charAt(3).toUpperCase() === 'C') {
      return PanType.Company;
    } else if (pan.charAt(3).toUpperCase() === 'H') {
      return PanType.HUF;
    } else if (pan.charAt(3).toUpperCase() === 'A') {
      return PanType.AOP;
    } else if (pan.charAt(3).toUpperCase() === 'B') {
      return PanType.BOI;
    } else if (pan.charAt(3).toUpperCase() === 'G') {
      return PanType.GovernmentAgency;
    } else if (pan.charAt(3).toUpperCase() === 'J') {
      return PanType.ArtificialJuridicalPerson;
    } else if (pan.charAt(3).toUpperCase() === 'L') {
      return PanType.LocalAuthority;
    } else if (pan.charAt(3).toUpperCase() === 'F') {
      return PanType.FirmLiabilityPartnership;
    } else if (pan.charAt(3).toUpperCase() === 'T') {
      return PanType.Trust;
    } else if (pan.charAt(3).toUpperCase() === 'P') {
      return PanType.Individual;
    }

    return undefined
  }

  convertFileToBase64(file: File): Promise<string | null> {
    return new Promise(resolve => {
      const reader = new FileReader();

      reader.onload = () => {
        resolve(reader.result as string);
      };

      reader.onerror = () => {
        resolve(null);
      };

      reader.readAsDataURL(file);
    });
  }

  getLatestGenieDate() {
    const url = environment.APIURL + "/api/v1/external/getLatestGenieDate";
    return this.http.get(url);
  }

  //#region Validators
  zeroNotAllowedValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

      const rawValue = control.value;

      if (rawValue === null || rawValue === '') {
        return null; // let required validator handle empty case
      }

      const numericValue = Number(
        String(rawValue).replace(/,/g, '')
      );

      if (isNaN(numericValue)) {
        return { zeroNotAllowed: true };
      }

      if (numericValue === 0) {
        return { zeroNotAllowed: true };
      }

      return null;

    };
  }


  atLeastOneSelected(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      return Array.isArray(value) && value.length > 0
        ? null
        : { atLeastOneRequired: true };
    };
  }

  //#endregion
  //Check if the class belongs to an employee
  isEmployee(clas: string, childFundId: string) {
    //IYP II and IYP II A
    if ((clas === 'C' || clas === 'E') && (childFundId === 'FUND241' || childFundId === 'FUND252')) return true;
    if (childFundId === 'FUND239' && ['F', 'G'].includes(clas)) return true; //ISAF
    if (childFundId === 'FUND261' && ['B3', 'C', 'E'].includes(clas)) return true;  //CSIP
    if (childFundId === 'FUND255' && ['B3', 'B4', 'YY'].includes(clas)) return true; //RYP
    if (childFundId === 'FUND371' && ['E', 'F'].includes(clas)) return true //GEF
    if (childFundId === 'FUND369' && ['F', 'E'].includes(clas)) return true; //IRAF
    if (childFundId === 'FUND370' && ['C', 'E', 'B3'].includes(clas)) return true; //ESOF IV
    if (childFundId === 'FUND395' && ['C1', 'C2', 'B3'].includes(clas)) return true; //Discovery II
    if (childFundId === 'FUND368' && ['C', 'E', 'B3'].includes(clas)) return true; //SSIF

    return false;
  }

  getEmployeeDocument(type: string) {
    const url =
      environment.APIURL +
      `/api/v1/external/masterData/1/nonindividualdocumenttype/${type}`;

    console.log('Constructed URL:', url);

    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);

    return this.http.get(url, { headers });
  }

  getEmployeeCodeFromImage(payload: any) {
    const url =
      environment.APIURL +
      `/api/v1/application/GetEmployeeCodeFromImage`;

    console.log('Constructed URL:', url);

    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    headers['Content-Type'] = 'application/json';

    return this.http.post(url, payload, { headers });
  }

  checkEmployeeCode(employeeCode: string) {
    const url =
      environment.APIURL +
      `/api/v1/application/CheckEmployeeCode?employeeCode=${employeeCode}`;

    console.log('Constructed URL:', url);

    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);

    return this.http.get(url, { headers });
  }
}
